var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns1,"data":_vm.ParkingLocks,"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }